import { render, staticRenderFns } from "./CropperLogo.vue?vue&type=template&id=d248d448&scoped=true"
import script from "./CropperLogo.vue?vue&type=script&lang=js"
export * from "./CropperLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d248d448",
  null
  
)

export default component.exports